import React, { useEffect, useRef, useState } from "react";
import { GeneralStyle } from "../EmailTemplateContainer/EmailTemplateContainer.styled";
import { useLocation, useHistory } from "react-router-dom";
import BackButtonComponent from "../../components/BackButtonComponent/BackButtonComponent";
import UpdateEmailTemplate from "../../components/UpdateEmailTemplate/UpdateEmailTemplate";
import { ContentWrapper } from "./UpdateEmailTemplateContainer.styled";
import { UPDATE_EMAIL_TEMPLATE } from "../../GraphQL/Mutations";
import { clientWellness } from "../../App";
import { NotificationManager } from "react-notifications";
import { useMutation, useLazyQuery } from "@apollo/client";
import { COUNTRIES_BY_CLIENT } from "../../GraphQL/Queries";
import ModalLoader from "../../components/ModalLoader/ModalLoader";

const UpdateEmailTemplateContainer = () => {
  const history = useHistory();
  const location = useLocation();
  const [body, setBody] = useState("");
  const [initialData, setInitialData] = useState();
  const rDescription = useRef();
  const rSubject = useRef();
  const [countrySelected, setCountrySelected] = useState([]);
  const [allCountries, setAllCountries] = useState([]);
  const [updateEmailTemplate] = useMutation(UPDATE_EMAIL_TEMPLATE, {
    client: clientWellness,
  });
  const allCountryObj = { label: "All", value: 0 };

  const [runQueryCountry, { loading: loadingQueryCountry }] = useLazyQuery(
    COUNTRIES_BY_CLIENT,
    {
      fetchPolicy: "network-only",
      onCompleted: (data) => {
        const resultOfAllCountries = [];
        resultOfAllCountries.push(allCountryObj);
        data.countryLocationList.forEach((element) => {
          resultOfAllCountries.push({
            value: element?.countryId,
            label: element?.countryName,
          });
        });
        setCountryForEditFlow();
        setAllCountries(resultOfAllCountries);
      },
    }
  );

  useEffect(() => {
    if (location.state.dataEmail) {
      setInitialData(location.state.dataEmail);
    }
    runQueryCountry({
      context: { clientName: "LinkUsers" },
    });
  }, [location.state.dataEmail]);

  const setCountryForEditFlow = () => {
    const emailTemplateData = location.state.dataEmail;
    if (emailTemplateData) {
      if (emailTemplateData.allCountries) {
        setCountrySelected(allCountryObj);
      } else {
        let selectedCountry = allCountries.find(
          (e) => e.value === emailTemplateData.idCountry
        );
        setCountrySelected(selectedCountry);
      }
    }
  };

  useEffect(() => {
    if (initialData) {
      rDescription.current.value = initialData.description;
      rSubject.current.value = initialData.emailSubject;
      setBody(initialData.emailBody);
    }
  }, [initialData]);

  useEffect(() => {
    if (allCountries && allCountries.length > 0) {
      setCountryForEditFlow();
    }
  }, [allCountries]);

  let goToBackPage = () => {
    history.push({ pathname: location.state.path });
  };

  const handleChangeSelectCountries = (e) => setCountrySelected(e);

  let validateData = () => {
    const allCountrySelected = countrySelected && countrySelected?.value === 0;
    updateEmailTemplate({
      variables: {
        idEmailTemplate: initialData?.idEmailTemplate,
        name: initialData?.name,
        description: rDescription.current.value,
        emailSubject: rSubject.current.value,
        emailBody: body,
        allCountries: allCountrySelected,
        idCountry: allCountrySelected ? null : parseInt(countrySelected.value),
        emailTemplateCode: initialData?.templateCode,
      },
    }).then(
      (saveResponse) => {
        NotificationManager.success(
          "Your information has been updated, Thank you!",
          "",
          5000
        );
        goToBackPage();
      },
      (error) => {
        const errorMessage = error.message.split("\n")[0];
        NotificationManager.error(errorMessage, "", 5000);
      }
    );
  };

  return (
    <GeneralStyle>
      <BackButtonComponent
        backtitle={"Email Templates"}
        locationtitle={"Update template"}
        goToBackPage={goToBackPage}
      />
      <hr style={{ marginLeft: "1.5rem", width: "96.5%" }} />
      <ContentWrapper>
        <UpdateEmailTemplate
          name={initialData?.name}
          goToBackPage={goToBackPage}
          validateData={validateData}
          body={body}
          setBody={setBody}
          rDescription={rDescription}
          rSubject={rSubject}
          allCountries={allCountries}
          countrySelected={countrySelected}
          handleChangeSelectCountries={handleChangeSelectCountries}
        />
      </ContentWrapper>
      {loadingQueryCountry && <ModalLoader />}
    </GeneralStyle>
  );
};

export default UpdateEmailTemplateContainer;
